import type { FaireProductEntity } from "../../entity_types/product";

export const p_vmc9rzbk4c: FaireProductEntity = {
  token: "p_vmc9rzbk4c",
  type: "product",
  name: "Deep Sea Notebook",
  brandName: "BV by Bruno Visconti",
  imageUrl:
    "https://cdn.faire.com/fastly/64bffa3fdc70994ddcb0e1364fc26a45a24427b23064d4682f56f9816a2849a5.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/35a852d184d2f10007658fe7938aeef420a25e0a918aabab9bd5122dbb557bf2.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
